import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'

export const PaymentFailed = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col space-y-3">
      <div className="flex flex-col items-center space-y-1">
        <AlertCircle className="w-10 h-10" />
        <h3 className="text-2xl font-semibold">{t('upgradePlanModal.paymentFailed.title')}</h3>
      </div>
      <p className="text-muted-foreground">{t('upgradePlanModal.paymentFailed.subtitle')}</p>
    </div>
  )
}
